import React from 'react';

import BaseComponent from 'src/components/BaseComponent';
import { withRouter } from 'src/helpers';

import model from './model';
import ClinicAppointmentDetail from './ClinicAppointmentDetail';
import AppointmentDetail from './AppointmentDetail';

class Detail extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    return model.getUser()?.isClinic || model.getUser()?.isManager ? (
      <ClinicAppointmentDetail />
    ) : (
      <AppointmentDetail />
    );
  }
}

export default withRouter(Detail);
